import { render } from "./customers-index.vue?vue&type=template&id=a8f75768"
import script from "./customers-index.vue?vue&type=script&lang=js"
export * from "./customers-index.vue?vue&type=script&lang=js"

import "./customers-index.vue?vue&type=style&index=0&id=a8f75768&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__